import { getErrorMessage } from "src/components/auth/utils";

import {
  ErrorMessageWrapper,
  ErrorText,
  ErrorTextContainer,
} from "src/styles/auth";

const SignInError = ({ error }: { error: string }) => {
  const { messageToBeDisplayed, isEmailOrWrongPassword, infoText } =
    getErrorMessage(error);
  if (isEmailOrWrongPassword) return null;
  return (
    <ErrorMessageWrapper>
      <ErrorText>{messageToBeDisplayed}</ErrorText>
      {!isEmailOrWrongPassword && (
        <ErrorTextContainer>{infoText}</ErrorTextContainer>
      )}
    </ErrorMessageWrapper>
  );
};

export default SignInError;
